/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import Select from 'components/select';
import ProvisioningStyles from 'pages/provisioning/day2-operation-paas/style';
import { sspSubmitOrder } from 'pages/provisioning/store/day2-operation-paas';

const ResourceGroup = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(sspSubmitOrder);
    const [options, setOptions] = React.useState([]);
    const setResourceGroup = (resourcGroup, resourcGroupDetail) => {
        setOrder({ ...order, resourcGroup, resourcGroupDetail });
    };
    const resourcGroupApi = useMutation(() => axios.get(`${endPoints.ssp.day2OperationPass.resourceGrp}`));
    const seldValueExistsInOptions = (resourcGroupValue) => options.find((option) => resourcGroupValue === option?.value);
    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.value)) {
            setResourceGroup(selected?.value, selected?.data);
        }
    };
    React.useEffect(() => {
        if (resourcGroupApi?.isSuccess) {
            if (resourcGroupApi?.data?.data) setOptions(resourcGroupApi?.data?.data?.map((app) => ({ label: app.name, value: app.name, data: app })));
        }
    }, [resourcGroupApi?.isSuccess]);

    React.useEffect(() => {
        resourcGroupApi.mutate();
    }, []);
    React.useEffect(() => {
        if (!order?.resourcGroup && order?.isTouched) setIsTouched(true);
    }, [order?.resourcGroup, order?.isTouched]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="resourcGroup"
                label="Resource group *"
                value={order?.resourcGroup || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                disabled={resourcGroupApi.isLoading}
                isLoading={resourcGroupApi.isLoading}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(ResourceGroup);
